export const FILE_STATUS = {
  DONE: 'done',
  REMOVED: 'removed',
  UPLOADING: 'uploading',
} as const;
